import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { RevisionSetTemplatePayload } from 'api/actions/revision-set-template/revision-set-template-payload';
import { RevisionSetTemplatePathParameters } from 'api/actions/revision-set-template/revision-set-template-path-parameters';
import { RevisionSetTemplateResponse } from 'api/actions/revision-set-template/revision-set-template-response';

type RevisionSetTemplateQueryParameters = Record<string, any>;

/**
 * The path of the RevisionSetTemplate action.
 */
export const revisionSetTemplateActionPath = new SweetPath<keyof RevisionSetTemplatePathParameters>(
  '/api/revision/set-template/{revisionId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized RevisionSetTemplate actions.
 */
export default function createRevisionSetTemplateAction(axios: AxiosInstance) {
  return function revisionSetTemplateAction({
    headers = {},
    parameters,
    query = {},
    payload,
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: RevisionSetTemplatePathParameters;
    query?: RevisionSetTemplateQueryParameters;
    payload: RevisionSetTemplatePayload;
  }) {
    const path = revisionSetTemplateActionPath.insert(parameters);

    return axios.request<RevisionSetTemplateResponse, RevisionSetTemplateResponse>({
      method: 'put',
      url: path,
      params: query,
      data: payload,
      headers,
    });
  };
}
